import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-push-finished-card',
  templateUrl: './push-finished.component.html',
  styleUrls: ['./push-finished.component.scss'],
  standalone: false,
})
export class PushFinishedComponent {
  @Input() status: string;
  @Input() siteId: string;

  constructor(private router: Router) {}

  goToOverview(): void {
    this.router.navigateByUrl(`/site/${this.siteId}/overview`);
  }
}
